import React from "react";
import { Table, Tooltip, Button } from "antd";
import { FormattedMessage } from "react-intl";
import FullName from "../../../components/tables/FullName";
import { useLocation } from "react-router-dom";
import { ScheduleOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";

const OverlapsTable = ({ data, loading, onlaunchApprovalModal, total }) => {
  const intl = useIntl();
  let location = useLocation();
  const branchPath = location.pathname.substring(
    0,
    location.pathname.lastIndexOf("/")
  );

  const columns = [
    {
      title: <FormattedMessage id="app.gaps.employee_name" />,
      dataIndex: "first_name",
      key: "first_name",
      render: (text, record) => {
        const name = {
          first_name: record.first_name || "",
          surename: record.surename || "",
        };
        return (
          <FullName
            record={name}
            customLocation={`${branchPath}/employees/${record.employee_id}`}
          />
        );
      },
    },
    {
      title: <FormattedMessage id="app.gaps.local_id_number" />,
      dataIndex: "local_id_number",
      key: "local_id_number",
    },
    {
      title: <FormattedMessage id="app.gaps.overlapsCount" />,
      dataIndex: "overlaps",
      key: "overlaps",
    },
    {
      title: <FormattedMessage id="app.gaps.actions" />,
      responsive: ["md"],
      width: "100px",
      render: (text, record) => {
        return (
          <div style={{ display: "flex" }}>
            <Tooltip
              title={intl.formatMessage({
                id: "app.gaps.fix_scheduling_gap",
              })}
            >
              <Button
                type="text"
                icon={<ScheduleOutlined />}
                onClick={() => onlaunchApprovalModal(record)}
              />
            </Tooltip>
          </div>
        );
      },
    },
  ];
  return (
    <Table
      columns={columns}
      dataSource={data}
      loading={loading}
      rowKey="employee_id"
      total={total}
    />
  );
};

export default OverlapsTable;
